import React, {useContext, useState} from "react";
import Button from '@mui/material/Button';
import { EventContext } from "./AdminEvents";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DetailCard from "./DetailCard";
import { TableBody, Table, TableContainer, TableRow, TableCell } from "@mui/material";
import {Link} from "@mui/material";

export default function AdminSingleEvent(props){

  const { setOverviewMode, setSingleViewMode, selectedEvent, setSelectedEvent, events } = useContext(EventContext)


  const eventBreakdown = events.find(e => e.eventDetails.eventName === selectedEvent)

  const backToEvents = () => {
    setOverviewMode(true)
    setSingleViewMode(false)
  }

  console.log(eventBreakdown)



  return (
    <div className="single-event-page">
      <Button onClick={() => backToEvents()}>Back to events</Button>
      <h3>{selectedEvent}</h3>
        <Grid container spacing={2}>
          <Grid sx={{padding: '0.5em'}} item xs={12}>
            <Card>
              <h5 className="inner-event-card">Event Details</h5>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>Event ID</TableCell>
                      <TableCell>{eventBreakdown.eventID}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Event Name</TableCell>
                      <TableCell>{eventBreakdown.eventDetails.eventName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Date of Event</TableCell>
                      <TableCell>{eventBreakdown.eventDetails.eventDate}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Venue</TableCell>
                      <TableCell>{eventBreakdown.eventDetails.venueName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Performance Time</TableCell>
                      <TableCell>{eventBreakdown.eventDetails.performTime}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Soundcheck Time</TableCell>
                      <TableCell>{eventBreakdown.eventDetails.soundcheckTime}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Performance Fee</TableCell>
                      <TableCell>{eventBreakdown.eventDetails.performFee}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Additional Fee</TableCell>
                      <TableCell>{eventBreakdown.eventDetails.addFee}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
          <Grid sx={{padding: '0.5em'}} item xs={12}>
            <Card>
              <h5 className="inner-event-card">Promoter Details</h5>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>Company Name</TableCell>
                      <TableCell>{eventBreakdown.promoterDetails.promoterName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Company Address</TableCell>
                      <TableCell>{eventBreakdown.promoterDetails.promoterAddress}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Contact Person</TableCell>
                      <TableCell>{eventBreakdown.promoterDetails.companyContactPerson}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Email</TableCell>
                      <TableCell>{eventBreakdown.promoterDetails.promoterEmail}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Contact Number</TableCell>
                      <TableCell>{eventBreakdown.promoterDetails.companyContactNo}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
          {/* <Grid sx={{padding: '0.5em'}} item xs={6}>
            <Card>
              <h5 className="inner-event-card">Travel Details</h5>
            </Card>
          </Grid> */}
          <Grid sx={{padding: '0.5em'}} item xs={12}>
            <Card>
              <h5 className="inner-event-card">Event Documents</h5>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>Invoice PoP</TableCell>
                      <TableCell>
                        {eventBreakdown.eventDocuments[0].docURL === '' ? 
                        <div className="outstanding-doc">Outstanding</div> : 
                        <a href={eventBreakdown.eventDocuments[0].docURL}>View</a>}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Signed Contract</TableCell>
                      <TableCell>
                        {eventBreakdown.eventDocuments[1].docURL === '' ? 
                        <div className="outstanding-doc">Outstanding</div> : 
                        <a href={eventBreakdown.eventDocuments[1].docURL}>View</a>}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Event Artwork</TableCell>
                      <TableCell>
                        {eventBreakdown.eventDocuments[2].docURL === '' ? 
                        <div className="outstanding-doc">Outstanding</div> : 
                        <a href={eventBreakdown.eventDocuments[2].docURL}>View</a>}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Hotel Reservations</TableCell>
                      <TableCell>
                        {eventBreakdown.eventDocuments[3].docURL === '' ? 
                        <div className="outstanding-doc">Outstanding</div> : 
                        <a href={eventBreakdown.eventDocuments[3].docURL}>View</a>}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Travel/ Flights</TableCell>
                      <TableCell>
                        {eventBreakdown.eventDocuments[4].docURL === '' ? 
                        <div className="outstanding-doc">Outstanding</div> : 
                        <a href={eventBreakdown.eventDocuments[4].docURL}>View</a>}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              
            </Card>
          </Grid>
        </ Grid>

    </div>
  )
}